export const checkError = {

    errorFormatting(data) {
        let errorList = [];
        if (data && data.errors && typeof data.errors === 'object') {
            Object.keys(data.errors).forEach(key => {
                errorList.push(
                    data.errors[key][0]
                );
            });
        } else {
            errorList.push(data ? data.message : data);
        }

        return errorList;

    },

    fieldErrorFormatting(data) {
        let errorMap = {};
        if (data && data.errors && typeof data.errors === 'object') {
            Object.keys(data.errors).forEach(key => {
                errorMap[key] = data.errors[key][0];
            });
        }
        return errorMap;
    }

} 